<template>
<div>

<div  class="modal" id="modalEpsonFiscalReceiptDepositDeduction" tabindex="-1" data-backdrop="static" data-keyboard="false" >
<div class="modal-dialog modal-dialog-centered"> 


<div  class="modal-content border border-success">

<div  style="background-color:#9acd32;color:black" class="modal-header border border-success text-nowrap ">
  <h4 class="modal-title ">
    <i style="color:blue" class="fas fa-cash-register mr-3" aria-hidden="true"></i>     
    <strong>STAMPA SCONTRINO FISCALE</strong>
    <hr>
    <span>{{ fiscalPrinter.url }}</span>
  </h4>  
</div>


<div  v-if="fiscalPrinter.fpId"  class="modal-body border border-success">
  <span style="color:red" v-if="msg.title"> {{ msg.body }}</span>

  <!--<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>-->
</div>
<div v-else class="modal-body border border-success">
    <div class="d-flex justify-content-center">
  <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>




</div>



<div class="modal-footer">
 
     <button  type="button" @click="closeModal(1)"  class="btn btn-secondary ">
      <i class="fas fa-reply mr-2" ></i>
        ANNULLA
    </button>

    <button  @click="postXML()" :disabled="bt_spinner==true" type="button" class="btn btn-primary ">
          <i class="fas fa-print mr-2" ></i>   
            STAMPA SCONTRINO 
          <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
    </button>    

    

</div>
</div>




</div>
</div>
</div>

</template>

<script>

import { mapGetters } from 'vuex';

import api               from '@/api'
import axios             from 'axios'
import alertBox          from '@/components/common/AlertBox.vue'


import getSaleData       from '@/components/rt/mixins/getSaleData'
import updateFPStatus     from '@/components/rt/mixins/UpdateFiscalPrintStatus'
import { setFmtDate4}    from '@/functions' 


  export default {
  mixins : [getSaleData,updateFPStatus],
  props  : ['saleId','balancePaymentSaleId'],

     components: {alertBox},
    data () {
      return {
        
          msg      : {title : '',body:'',type :0},
        
          deskId      : 1,  
          items       : [],
         
          bt_spinner  : false,
          paid        : 1,
          items       : [],
          payments    : [],
          balance_payments     : [],
          fiscalPrinter : {}
                                   
      }
    },
    computed: 
  {
   ...mapGetters(['storeId','company']) ,   
      
     
  },
      
    async created () 
      {
        
        let deskId = JSON.parse(localStorage.getItem("deskId"))
        if(deskId)
        {    
            this.deskId = Number(deskId)
        }
        
        this.fiscalPrinter =  await this.getFiscalPrinter(this.storeId,this.deskId)  
        
        if(this.fiscalPrinter.fpId == 1)
        {
          this.$nextTick(()  => {                  
            $('#modalEpsonFiscalReceiptDepositDeduction').modal('show')
        
            })   
            this.getData()
            this.getBalancePayments()  
       }    
           
      },
    
    methods: 
    {
    
      
    async getFiscalPrinter(storeId,deskId)
    {
    
    const sp    = {'sp':'spStoreDeskFiscalPrinter'}
    const data  = {'storeId': storeId,'deskId': deskId}      
    const json  = Object.assign(data, sp)
    return new Promise( async (resolve, reject)  =>  {  
      
      api.post(json).then(res => {
      if(res.status==200)
        {
          
         if(res.data.recordsets[0].length > 0) 
         {
            resolve(res.data.recordsets[0][0])
                       
         }
         
        }
        else if(res.status==500)
        {
         
          resolve({})
        
        } 
        else
        {
          resolve({})
        
        } 
    }).catch(err => 
    {
      
      resolve({})
       
    }).finally(() => {
      
    });

  })

   },

    closeModal(hideModal)
    {   
        if(hideModal)
        {
          $('#modalEpsonFiscalReceiptDepositDeduction').modal('hide')  
        }
        
        this.$nextTick(()  => {              
          this.$emit('close')        
          })    
    },  
     parseFiscalReceiptResponse(xmlResponse)
     {

      const parser              = new DOMParser()
      const xmlDoc              = parser.parseFromString(xmlResponse,"text/xml")
      const response            = xmlDoc.getElementsByTagName("soapenv:Body")[0].childNodes[0].nextSibling.attributes[0].value
      
      const serialNumber        = this.fiscalPrinter.badge
      let fiscalReceiptNumber   = ''
      let zRepNumber            = ''
      
      let fiscalReceiptDate     = ''

      if(response == 'true')
      {
        fiscalReceiptNumber       = xmlDoc.getElementsByTagName("fiscalReceiptNumber")[0].childNodes[0].nodeValue
        fiscalReceiptNumber       = fiscalReceiptNumber.padStart(4,'0')
        zRepNumber                = xmlDoc.getElementsByTagName("zRepNumber")[0].childNodes[0].nodeValue
        zRepNumber                = zRepNumber.padStart(4,'0')
        
       
        fiscalReceiptDate         = setFmtDate4(xmlDoc.getElementsByTagName("fiscalReceiptDate")[0].childNodes[0].nodeValue)
      }
      
      return { 'fiscalReceiptNumber' : fiscalReceiptNumber,
               'zRepNumber'          : zRepNumber,
               'fiscalReceiptDate'   : fiscalReceiptDate,
               'serialNumber'        : serialNumber}
     },
     async saveFiscalReceiptResponse(saleId,data)
     {

      const sp         = {'sp'   : 'spCreateSaleFiscalReceipt'}          
      const json       = Object.assign(data, sp,{'saleId':saleId})
          
      await api.post(json).then(res => {
        if(res.status==200)
            {
              console.log(res.data)
            }
          else if(res.status==500)
           { 
            console.log(res.data)
           }  
           else
            {
              
                
                /*
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                */
                
                 
            } 
          }).catch(err => {
              
              

          }).finally(() => {
          
        });

      
          
     },   
     getXML() 
     {
        
        let xml = ''  
          
        let SubtotalAdjustment = this.items[0].total_discount
        let total_deposit = 0

        this.payments.forEach(item=>{
              

              if(item.typeId == 'CASH' || item.typeId == 'ELEC' || item.typeId == 'EDEN')  
              {
                total_deposit += item.amount
              }

              

              if(item.typeId == 'COUP')
              {
                SubtotalAdjustment += item.amount
              }
              if(item.typeId == 'CB')
              {
                SubtotalAdjustment += item.amount
              }
        })  
                    
        xml = '<printerFiscalReceipt> <beginFiscalReceipt  operator="1" />'
        xml += '<Printer Num="1" />'
                
        this.items.forEach(item => {                        
              xml += '<printRecItem operator="1" description="' + item.barcode + " "  + item.category + '" quantity="1" unitPrice="' + item.price + '" justification = "1" />'            
              if(Number(item.discount > 0))
              {
                xml += '<printRecItemAdjustment operator="1" adjustmentType="0" description="SCONTO ' + item.discount + '%"' + ' amount="' + item.discount_value + '" justification = "1" />'  

              }
        })
        
        // DEPOSIT DEDUCTION
        xml += '<printRecItemAdjustment operator="1" adjustmentType="10" description="DEDUZIONE ACCONTO "  amount="' + total_deposit + '" justification = "1" />'  
        
        
        if(SubtotalAdjustment != '0.00')
        {
            xml += '<printRecSubtotalAdjustment operator="1" description="SCONTO" Type="1" amount="' + SubtotalAdjustment + '" justification = "2" />'
        }

    
        xml += '<printRecSubtotal operator="1" Type="1"/>'
        xml += '<printBarCode operator="1" position="901" width="3" height="120" HRIPosition="1" HRIFont="A" codeType="69" code="' + "S" +  this.balancePaymentSaleId + '"/>'         

     
        this.balance_payments.forEach(item => {
            if(item.typeId == 'CASH')
            {          
              xml += '<printRecTotal operator="1" description="Pagamento contante" amount="' + item.amount + '" Type="0" index="3" justification = "2" />'
            }
            if(item.typeId == 'ELEC')
            {
                xml += '<printRecTotal operator="1" description="Pagamento elettronico" amount="' + item.amount + '" Type="2" index="1" justification = "2" />'                  
            }
            
          })  

           
            

          xml += '<endFiscalReceipt  operator="1" /></printerFiscalReceipt>'
          
          console.log('EPSON FISCAL RECEIPT WITH DEPOSIT DEDUCTION',xml)  
          return xml              
      },
   
      getSOAP(xml)
      {
            const soap = '<?xml version="1.0" encoding="utf-8"?>\n' +
            '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">\n' +
              '<s:Body>\n' + xml +
            '</s:Body>\n' +
            '</s:Envelope>\n'
            return soap
      },
      getData()
      { 
        
        
        
        const data     = this.getSaleData(this.saleId)
        data.then((res) => { 
            console.log('SALE DATA ',res);
            this.items     = res[0]
            this.payments  = res[1]
            //this.postXML()
          }).catch((err) => { 
            this.items     = []
            this.payments  = []
            console.log(err);
            });
      },
      getBalancePayments()
      { 
                
        
        const data      = this.getSaleData(this.balancePaymentSaleId)
        data.then((res) => { 
            console.log('BALANCE SALE DATA PAYMENTS',res);
            //this.items     = res[0]
            this.balance_payments  = res[1]
            
          }).catch((err) => { 
            //this.items     = []
            this.balance_payments  = []
            console.log(err);
            });
      },
      postXML()      
      {   

          this.msg.title = ''
          this.bt_spinner = true
          const url  = this.fiscalPrinter.url
          const soap = this.getSOAP(this.getXML())
          axios({
               
               url    : url + '/cgi-bin/fpmate.cgi',
               method : 'post',
               data   : soap

             }).then(res => {
                this.bt_spinner = false
                console.log('RT Response',res)
                const response = this.parseFiscalReceiptResponse(res.data)
                if(response.fiscalReceiptNumber )
                {
                  this.saveFiscalReceiptResponse(this.balancePaymentSaleId,response)
                  this.updateFiscalPrintStatus(this.balancePaymentSaleId)
                  
                  this.closeModal(1)

                }
                
             }).catch(err => {
                
                this.bt_spinner   = false   
               
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = err
                this.msg.type  = 1                          
                
               console.log('Errore Fiscal Printer ',err)  
             })
       
      }, 

   
     } 
      

    
  }
</script>
<style scoped>


.modal-footer {  
  justify-content: space-between;  
}


 
  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.modal-content
{
  width:  500px;
}
.form-check-label
{
  cursor: pointer;
}

</style>
